const catalog = {
  "mixer-amplifier": `CP-120M|120W Mini Mixer Amplifier|19500
CP-240M|240W Mini Mixer Amplifier|30000
CP-350M|350W Mini Mixer Amplifier|39000
CP-500M|500W Mini Mixer Amplifier|45500
EA-30T|2 Zone 30W Mixer Amplifier|18000
EA-60T|2 Zone 60W Mixer Amplifier|23500
EA-120T|2 Zone 120W Mixer Amplifier|30000
DC-120A|120W 19" 1U Mixer Amplifier|25500
DC-240A|240W 19" 1U Mixer Amplifier|33500
DC-500A|500W 19" 1U Mixer Amplifier|45000
DC-120AB|120W 19" 1U Mixer Amplifier|28500
DC-240AB|240W 19" 1U Mixer Amplifier|37000
DC-500AB|500W 19" 1U Mixer Amplifier|50500
EA-120Z|120W 5 Zone Mixer Amplifier|27000
EA-240Z|240W 5 Zone Mixer Amplifier|39500
EA-500Z|500W 5 Zone Mixer Amplifier|49000
FA-350Z|350W 3 Zone Mixer Amplifier|44500
DC-120Z|120W 6 Zone Mixer Amplifier|27000
DC-240Z|240W 6 Zone Mixer Amplifier|32500
DC-500Z|500W 6 Zone Mixer Amplifier|46500
DC-120ZB|120W 6 Zone Mixer Amplifier|30000
DC-240ZB|240W 6 Zone Mixer Amplifier|36000
DC-500ZB|500W 6 Zone Mixer Amplifier|52500
DB-120A|120W Mixer Amplifier|28000
DB-240A|240W Mixer Amplifier|36000
DB-500A|500W Mixer Amplifier|45500
DA-120MT|6 Zone 120W Mixer Amplifier|33000
DA-240MT|6 Zone 240W Mixer Amplifier|42000
DA-500MT|6 Zone 500W Mixer Amplifier|48500
PA-2120MX|2 Zone Matrix Mixer Amplifier|36500
PA-2500MX|2 Zone Matrix Mixer Amplifier|60500
PA-4120MX|4 Zone Matrix Mixer Amplifier|45000
PA-4350MX|4 Zone Matrix Mixer Amplifier|66500
PA-4500MX|4 Zone Matrix Mixer Amplifier|78500
PA-6060MX|6 Zone Matrix Mixer Amplifier|73000
PA-6120MX|6 Zone Matrix Mixer Amplifier|79000
PA-6240MX|6 Zone Matrix Mixer Amplifier|86000`,
  "wifi-amplifier": `EA-30W|30W Wi-Fi Streaming Amplifier|23500
EA-60W|60W Wi-Fi Streaming Amplifier|27000
EA-120W|120W Wi-Fi Streaming Amplifier|35500
EA-60TW|2 Zone 60W Wi-Fi Mixer Amplifier|31500
EA-120TW|2 Zone 120W Wi-Fi Mixer Amplifier|41000
DA-120MW|6 Zone 120W Wi-Fi Mixer Amplifier|44000
DA-350MW|6 Zone 350W Wi-Fi Mixer Amplifier|57500
PA-2120MW|2 Zone Wi-Fi Matrix Mixer Amplifier|46000
PA-2500MW|2 Zone Wi-Fi Matrix Mixer Amplifier|69000
PA-4120MW|4 Zone Wi-Fi Matrix Mixer Amplifier|55500
PA-4350MW|4 Zone Wi-Fi Matrix Mixer Amplifier|77500
PA-4500MW|4 Zone Wi-Fi Matrix Mixer Amplifier|86000
PA-6060MW|6 Zone Wi-Fi Matrix Mixer Amplifier|83000
PA-6120MW|6 Zone Wi-Fi Matrix Mixer Amplifier|85500
PA-6240MW|6 Zone Wi-Fi Matrix Mixer Amplifier|93000`,
  "power-amplifier": `DA-240|Single Channel Class-D Amplifier|36000
DA-500|Single Channel Class-D Amplifier|44500
DA-2240|Two Channel Class-D Amplifier|40000
DA-2500|Two Channel Class-D Amplifier|50000
DA-4120|Four Channel Class-D Amplifier|50500
DA-4500|Four Channel Class-D Amplifier|75500
CS-2300|Power Amplifier|37000
CS-4300|Power Amplifier|45000
DS-2300|High SPL Two Channel Power Amplifier|47500
DS-4300|High SPL Four Channel Power Amplifier|63500
DSP-2400|Power Amplifier with DSP & Dante|87000
DSP-4400|Power Amplifier with DSP & Dante|114000
DST-2400|Power Amplifier with DSP Processor|83500
DST-4400|Power Amplifier with DSP Processor|101000
DSP-4120|Power Amplifier with DSP & Dante|98000
DSP-4240|Power Amplifier with DSP & Dante|100000
DSP-4500|Power Amplifier with DSP & Dante|104500
DST-4120|Power Amplifier with DSP Processor|91500
DST-4240|Power Amplifier with DSP Processor|93500
DST-4500|Power Amplifier with DSP Processor|98500`,
  "audio-source": `DMT200|DVD/CD Player/MP3/Tuner|25000`,
  "ceiling-speaker": `CSK-56PC|5" Ceiling Speaker with Back Box|1700
CSK-66PC|6.5" Ceiling Speaker with Back Box|1800
CSK-610HA|6.5" Coaxial Ceiling Speaker|2700
CSK-56HF|5" Frameless Ceiling Speaker|1100
CSK-66HF|6.5" Frameless Ceiling Speaker|1300
CSK-810HF|8" Frameless Ceiling Speaker|1600
CSK-66HC|6.5" Frameless Ceiling Speaker with Back Can|1800
CSK-810HC|8" Frameless Ceiling Speaker with Back Can|2100
CSK-66WE|6.5" Waterproof Ceiling Speaker|1900
CSK-66WEC|6.5" Waterproof Ceiling Speaker with Back Can|2500
CSK-56W|5" Metal Ceiling Speaker|1500
CSK-66M|6.5" Metal Ceiling Speaker|1600
CSK-66MC|6.5" Metal Ceiling Speaker with Fire Dome|2200
CSK-520T|5" 2-Way Ceiling Speaker|3200
CSK-520K|5" 2-Way Ceiling Speaker with ABS Cover|4200
CSK-630K|6.5" 2-Way Ceiling Speaker with ABS Cover|5500
CSK-613HT|6.5" 2-Way Frameless Ceiling Speaker|3900
CSK-613HR|6.5" 2-Way Frameless Ceiling Speaker|4300
CSK-512HTM|5" 2-Way Ceiling Speaker with Back Can|4400
CSK-613HTM|6.5" 2-Way Ceiling Speaker with Back Can|5500
CSK-430HT|4" 2-Way Frameless Ceiling Speaker|5500
CSK-540HT|5" 2-Way Frameless Ceiling Speaker|6000
CSK-430HR|4" 2-Way Frameless Ceiling Speaker|5500
CSK-540HR|5" 2-Way Frameless Ceiling Speaker|6500
CSK-430HM|4" 2-Way Frameless Ceiling Speaker with Fire Dome|5500
CSK-540HM|5" 2-Way Frameless Ceiling Speaker with Fire Dome|6500
CSK-860HM|6.5" 2-Way Frameless Ceiling Speaker with Fire Dome|8500`,
  "wall-speaker": `WSK-33T|3" Waterproof Wall Mount Speaker|1400
WSK-46M|4" Wall Mount Speaker|2800
WSK-56C|5" Wall Mount Speaker|3200
WSK-610C|6.5" Wall Mount Speaker|3800
WSK-640DS|6.5"+1" 2-Way Wall Mount Speaker, Black|10000
WSK-640DSW|6.5"+1" 2-Way Wall Mount Speaker, White|10000
WSK-422S|4" 2-Way Wall Mount Speaker, Black|4400
WSK-523S|5.25" 2-Way Wall Mount Speaker, Black|5000
WSK-624S|6.5" 2-Way Wall Mount Speaker, Black|5500
WSK-422SW|4" 2-Way Wall Mount Speaker, White|4400
WSK-523SW|5.25" 2-Way Wall Mount Speaker, White|5000
WSK-624SW|6.5" 2-Way Wall Mount Speaker, White|5500
WSK-R30B|5.25" 2-Way Wall Mount Speaker, Black|6000
WSK-R30W|5.25" 2-Way Wall Mount Speaker, White|6000
SUB-812HT|Super Bass Wooden Box Speaker|21000`,
};

const typeNames = {
  "mixer-amplifier": "Mixer Amplifier",
  "wifi-amplifier": "WiFi Amplifier",
  "power-amplifier": "Power Amplifier",
  "audio-source": "Audio Sources Player",
  "ceiling-speaker": "Ceiling Speaker",
  "wall-speaker": "Wall Mount Speaker",
};

const getWatts = (description) => Number(description.match(/(\d+(?:\.\d+)?)W\b/i)?.[1]) || undefined;
const getZones = (description) => Number(description.match(/(\d+)\s*Zone/i)?.[1]) || undefined;

export const requestedPaProducts = Object.entries(catalog).flatMap(([componentType, rows]) =>
  rows.split("\n").map((row) => {
    const [model, productName, price] = row.split("|");
    return {
      id: `cmx-${model.toLowerCase()}`,
      brand: "CMX",
      installationType: "wired",
      systemFamily: typeNames[componentType],
      componentType,
      productName,
      model,
      unit: "Nos.",
      unitPrice: Number(price),
      currency: "BDT",
      priceStatus: "user-supplied",
      active: true,
      ...(getWatts(productName) ? { powerWatts: getWatts(productName) } : {}),
      ...(getZones(productName) ? { numberOfZones: getZones(productName) } : {}),
    };
  })
);

export const requestedPaBrands = ["CMX"];
